import script from "./TabInquiryContent.vue?vue&type=script&setup=true&lang=js"
export * from "./TabInquiryContent.vue?vue&type=script&setup=true&lang=js"

import "./TabInquiryContent.vue?vue&type=style&index=0&id=4ccb31d0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4ccb31d0"]])

export default __exports__